import { type PlayableRoomGameId, playableRoomGameIdSet } from "./roomGameCatalog";

const GAME_QUERY_KEY = "game";
const START_QUERY_KEY = "start";

export function gameLaunchPath(gameId: PlayableRoomGameId): string {
  const search = new URLSearchParams({ [GAME_QUERY_KEY]: gameId, [START_QUERY_KEY]: "1" });
  return `/app?${search.toString()}`;
}

export function gameLaunchIntent(search: string): PlayableRoomGameId | null {
  const params = new URLSearchParams(search);
  const gameId = params.get(GAME_QUERY_KEY);
  if (params.get(START_QUERY_KEY) !== "1" || !gameId || !playableRoomGameIdSet.has(gameId))
    return null;
  return gameId as PlayableRoomGameId;
}
